import { NAME_DOCUMENT_FOR_USER, KEY_STORAGE_FOR_USER } from "constants"

import React, { useLayoutEffect, useState } from "react"

import CustomButton from "components/CustomButton"
import CustomInput from "components/CustomInput"
import Modal from "components/Modal"
import { useGameInforContext } from "contexts/GameInforProvider"
import { addDocument } from "firebase-helper/firestore-services"
import useLocalStorage from "hooks/useLocalStorage"
import { showNotification } from "utils"
import { v4 as uuidv4 } from "uuid"

const Header = () => {
    const { user, setUser } = useGameInforContext()
    const [userInStorage, setUserInStorage] = useLocalStorage(KEY_STORAGE_FOR_USER, "")

    const [isModalDisplayed, setIsModalDisplayed] = useState(false)
    const [username, setUsername] = useState("")

    useLayoutEffect(() => {
        if (userInStorage?.name && userInStorage?.id){
            setUser(userInStorage)
            setIsModalDisplayed(false)
        } else {
            setIsModalDisplayed(true)
        }
    }, [userInStorage])

    const handleCreateUser = async() => {
        if (!username){
            showNotification("error", "Bạn yêu chưa nhập tên ^^")

            return
        }
        const userId = uuidv4()

        await addDocument(
            NAME_DOCUMENT_FOR_USER,
            {
                name: username
            },
            userId
        )

        setIsModalDisplayed(false)

        const user = {
            id   : userId,
            name : username
        }

        setUserInStorage(user)

        setUser(user)
    }

    if (!user.name){
        return (
            <Modal
                clickOutsideToClose={ false }
                close={ () => setIsModalDisplayed(false) }
                escToClose={ false }
                hasCloseButton={ false }
                isOpen={ isModalDisplayed }
            >
                <div className="tablet:w-[400px] w-[280px] h-auto overflow-visible text-secondary px-4 py-6">
                    <div className="relative">
                        <CustomInput
                            value={ username }
                            onChange={ (e) => {
                                const { value } = e.target
                                if (value.length > 12){
                                    return
                                }
                                setUsername(value)
                            } }
                        />

                        <p className="absolute right-2 top-1/2 text-quinary text-sm -translate-y-1/2	">
                            { 12 - username.length }
                        </p>
                    </div>

                    <p className="mt-1 text-quinary text-sm italic text-right">Tối đa 12 kí tự</p>

                    <CustomButton className="block mx-auto mt-6" onClick={ handleCreateUser }>
                        Nhập tên bạn
                    </CustomButton>
                </div>
            </Modal>
        )
    }

    return (
        <header className={ `w-full h-auto bg-primary text-white p-2 text-center` }>
            <p className={ " text-lg font-semibold" }>Xin chào { user.name }</p>

            <p className={ "text-center text-sm" }>daudit chúc bạn yêu luôn mạnh khỏe ,thành công</p>
        </header>
    )
}

export default Header
